import React, { useState } from "react";
import { simulateTrades } from "../services/api.js";
import { useToasts } from "./ToastHost.js";

export default function SimulationPanel(){
  const [tickers, setTickers] = useState("AAPL,MSFT,GOOGL");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [tp, setTp] = useState(2.0);
  const [sl, setSl] = useState(1.0);
  const [msg, setMsg] = useState("");
  const { push } = useToasts();

  const run = async () => {
    setMsg("Starte Simulation…");
    try{
      const payload = {
        tickers: tickers.split(",").map(t=>t.trim()).filter(Boolean),
        start: start || undefined,
        end: end || undefined,
        tp_pct: parseFloat(tp),
        sl_pct: parseFloat(sl),
      };
      const res = await simulateTrades(payload);
      setMsg(`Fertig: ${res.written_trades} Trades gespeichert.`);
      push("Simulation abgeschlossen");
    }catch(e){ setMsg(`Fehler: ${e.message}`); push(`Fehler: ${e.message}`,"error"); }
  };

  return (
    <div className="card">
      <div className="font-semibold mb-2">Simulation</div>
      <div className="space-y-2 text-sm">
        <label className="block">Tickers (CSV)
          <input className="w-full border rounded px-2 py-1" value={tickers} onChange={e=>setTickers(e.target.value)} />
        </label>
        <div className="grid grid-cols-2 gap-2">
          <label>Start
            <input type="date" className="w-full border rounded px-2 py-1" value={start} onChange={e=>setStart(e.target.value)} />
          </label>
          <label>Ende
            <input type="date" className="w-full border rounded px-2 py-1" value={end} onChange={e=>setEnd(e.target.value)} />
          </label>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label>TP %
            <input type="number" step="0.1" className="w-full border rounded px-2 py-1" value={tp} onChange={e=>setTp(e.target.value)} />
          </label>
          <label>SL %
            <input type="number" step="0.1" className="w-full border rounded px-2 py-1" value={sl} onChange={e=>setSl(e.target.value)} />
          </label>
        </div>
        <button className="btn btn-primary" onClick={run}>Simulation starten</button>
        {msg && <div className="text-xs opacity-80">{msg}</div>}
      </div>
    </div>
  );
}